<template>
  <div class="setting_select">
    <el-form-item :label="view_field_label" v-if="index==0">
      <el-select v-model="value" clearable placeholder="请选择" @change="changeItem">
        <el-option
          v-for="item in options"
          :key="item.option_value"
          :label="item.option_label"
          :value="item.option_value">
        </el-option>
      </el-select>
    </el-form-item>

    <el-form-item :label="view_field_label" v-if="index==1">
      <el-select v-model="value1" clearable placeholder="请选择">
        <el-option
          v-for="item in optionsChildren"
          :key="item.option_value"
          :label="item.option_label"
          :value="item.option_value">
        </el-option>
      </el-select>
    </el-form-item>

  </div>
</template>

<script>
  export default {
    name: "setting_select",
    props: {
      formList: {
        type: '',
        required: true,
        default: () => {
        }
      },
      view_field_label: {
        type: '',
        required: true,
        default: () => {
        }
      },
      index: {
        type: '',
        required: true,
        default: () => {
        }
      }
    },
    watch: {
      formList() {
        this.formList.field_cascade_optional_value_list.forEach((v, i) => {
          v.index = i
          this.options.push(v)
        })
      },
    },

    data() {
      return {
        options: [],
        optionsChildren: [],
        value: '',
        value1: ''
      }
    },
    methods: {
      changeItem(val) {
        let obj = this.options.find(sub => val == sub.option_value)
        console.log(obj);
        // this.optionsChildren = []
        // this.options.forEach((v, i) => {
        //   if (val == v.option_value) {
        //     v.children.forEach((v1, i1) => {
        //       this.optionsChildren.push(v1)
        //     })
        //   }
        // })
        // this.$forceUpdate();
        // console.log(this.optionsChildren, 'yyyy');
      }
    }
  }
</script>

<style scoped>
  .el-input__suffix {
    top: 5px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/bpm_setting/setting_select.vue